import React from 'react'
import { GrayWrapper } from '@appearance/styled'
import LogsTable from '@components/settings/LogsTable'

export default ({ show }) => {
    if (!show) {
        return null
    }
    return (
        <GrayWrapper>
            <LogsTable />
        </GrayWrapper>
    )
}
